import axios from 'axios';
import { configRefs } from '@utils/constants';

async function updateDialogueRequest(user, dialogueId, message) {
  if (!user) {
    throw new Error("updateDialogueRequest(): cannot send a message if a sender has not been defined.");
  }
  if ((await configRefs.env.node.get()) !== "production") {
    console.warn("updateDialogueRequest(): dialogue not sent due to NODE_ENV");
    return;
  }
  await axios.put(`${await configRefs.apis.userdata.get()}/api/Dialogues/${dialogueId}`, {
    author: {
      id: user.id,
      type: user.role
    },
    content: message
  });
}

export { updateDialogueRequest };
//# sourceMappingURL=api.update-dialogue.request.js.map
